import { MouseEventHandler } from 'react';
import { NavLink } from 'react-router-dom';

const strings = {
  title: 'Жертвы Кровавого января',
  menu: {
    about: 'Подробнее',
    sendData: 'Дополнить информацию',
    share: 'Поделиться',
  },
  searchPlaceholder: 'Введите имя',

  footer: {
    followUs: 'Подпишитесь на нас',
    copyright: '© 2022 RFE/RL, Inc. | Все права защищены ',
    contentTitle: 'О Радио',
    content: `Радио Азаттык – независимое СМИ, распространяющее информацию в тех странах, где ограничена свобода слова. Азаттык поддерживает принципы демократии и соблюдения прав человека, практикуемые в демократических обществах. Корреспонденты Азаттыка делают всё возможное, чтобы обеспечить точность информации в публикациях. Мы раскрываем темы, которые, возможно, замалчиваются в других СМИ, и предлагаем их читателям через открытые дискуссии и без цензуры.`,
    creatorsTitle: 'Над проектом работали',
    creators: (
      <p>
        <strong>Автор:</strong> Дархан Омирбек
        <br />
        <strong>Репортер:</strong> Дина Имамбай
        <br />
        <strong>Редактор:</strong> Дархан Омирбек, Жаннат Нугманова <br />
        <strong>Дизайн и верстка:</strong> Pangea Digital Dataviz team
        <br />
        <strong>Супервайзер:</strong> Мухтар Сенгирбай
      </p>
    ),
  },

  home: {
    intro: (onClick: MouseEventHandler<HTMLAnchorElement>) => (
      <p>
        Это проект Азаттыка, посвященный жертвам Кровавого января – событий в январе 2022 года,
        когда мирные протесты закончились кровопролитием. Микросайт дает возможность{' '}
        <a href="#" onClick={onClick}>
          ознакомиться с фактами из жизни погибших
        </a>
        , <NavLink to="about">узнать, как развивались события</NavLink>, и{' '}
        <NavLink to="send-data">добавить новые сведения</NavLink>.
      </p>
    ),
    detailButton: 'Читать',
    listTitle: 'Все жертвы',
    noResults: 'Ничего не найдено',
    allVictims: 'Все жертвы',
    updated: 'Обновлено:',
  },
  search: {
    listTitle: 'Результаты',
    title: 'Поиск',
    description: (search: string) => (
      <p>
        Вы искали: <em>{search}</em>
      </p>
    ),
    noResults: 'Ничего не найдено',
  },
  sendData: {
    title: 'Отправить информацию',
    content: (
      <p>
        В работе над проектом о жертвах январских событий Азаттык опирался на открытые источники и
        информацию, предоставленную родственниками погибших. К сегодняшнему дню установить личности
        всех официально объявленных 238 погибших не удалось. В некоторых случаях нам были известны
        имена и фамилии, однако родственники отказывались сообщать подробности, ссылаясь на разные
        личные причины. Если в нашем списке погибших вы не нашли человека, которого знали, или
        имеете возможность дополнить информацию, пожалуйста, свяжитесь с нами. Вы можете отправить
        данные через мессенджеры WhatsАpp, Telegram и электронную почту. Проект предполагает
        отправку данных на анонимной основе.
      </p>
    ),
    subtitle: 'Отправить сведения о жертве января',
    globalLeaks: 'Отправить анонимно',
  },
  profile: {
    judgement: 'Жазо',
    accusation: 'Айблов',
    persecution: 'Таъқиб',
    prohibition: 'Тақиқ',
    exileBan: 'Қувғин',
    work: 'Нашр',
    occupation: 'Фаолияти',
    detainedTime: 'Ҳодиса вақти',
    prisonTerm: 'Қамоқ муддати',
    releasedTime: 'Қамоқдан чиққан вақти',
    pressure: 'Тазйиқ',
    internationalReaction: 'Халқаро реакция',

    dateOfBirth: 'Дата рождения:',
    ageOfDeath: 'Возраст на момент смерти:',
    dateOfDeath: 'Дата смерти:',
    placeOfDeath: 'Место смерти:',
    placeOfResidence: 'Место проживания:',
    //occupation: 'Статус участника/цы:',
    share: 'Поделиться страницей:',
    relatedVictims: 'Связанные истории:',
    sendData: 'У вас имеются дополнительные данные об этом человеке? ',
    missingData: 'Неизвестно',
    source: 'Источник',
    informationConfirmed: 'Подтверждено документами',
    waitingForConfirmation: 'Получена информация от нескольких источников, ждем документы',
  },
};

export default strings;
